import { useEffect, useState } from "react";
import { useAppState, Steps } from "../../state";
import { styled } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import useHeight from "../../hooks/useHeight/useHeight";
import IntroContainer from "../IntroContainer/IntroContainer";
import HelpDeskView from "./HelpDeskView";
import FindItemView from "./FindItemView";
import PickOrderView from "./PickOrderView";
import { ClientFetch, ClientCoverImage } from "../../data/ClientData";
import ThankYouView from "./ThankYouView";

const Container = styled("div")({
  display: "grid",
  gridTemplateRows: "1fr auto"
});

export default function LandingClient() {
  const {
    isFetching,
    currentStep,
    setCurrentStep,
    clientID,
    setClientID,
    locationID,
    setLocationID,
    setDcxClientData,
    logoURL,
    setLogoURL,
    dcxClientName,
    setDcxClientName,
    serviceURL,
    setServiceURL,
    coverURL,
    setCoverURL
  } = useAppState();

  const [clientExist, setClientExist] = useState(false);
  const [selectedOption] = useState("");
  const height = useHeight();
  const url = new URL(window.location.href);
  const urlClientID = url.searchParams.get("ClientID") as string;
  const urlLocationID = url.searchParams.get("LocationID") as string;
  const thankyou = url.searchParams.get("ThankYou") as string;
  const clientCover = ClientCoverImage(urlClientID);
  const dcxClient = {
    clientID,
    locationID,
    dcxClientName,
    logoURL,
    coverURL,
    serviceURL
  };
  localStorage.setItem("DCXCLIENT", JSON.stringify(dcxClient));

  useEffect(() => {
    const controller = new AbortController();

    // If we're showing thank you page and already have client data, don't refetch
    if (thankyou === "true" && clientID && dcxClientName) {
      setClientExist(true);
      setCurrentStep(Steps.thankYouView);
      return;
    }

    localStorage.removeItem("DCXCLIENTCustomer");
    localStorage.removeItem("DCXCLIENT");
    localStorage.removeItem("DCXCliSig");

    const fetchClient = async () => {
      try {
        const acceptedURL = window.location.search.toString();
        if (!urlClientID) {
          window.location.assign("/landing");
          return;
        }
        const clientData = await ClientFetch(urlClientID);
        console.log(clientData);

        if (!clientData) {
          console.error("Failed to fetch client data");
          setCurrentStep(Steps.landingPage);
          return;
        }

        setClientID(urlClientID);
        setClientExist(true);
        setDcxClientData(clientData);
        setServiceURL(acceptedURL);
        setLocationID(urlLocationID);
        if (clientData.PhoneLogoURL && clientData.PhoneLogoURL.trim() !== "") {
          setLogoURL(clientData.PhoneLogoURL);
        }
        if (clientData.ClientName && clientData.ClientName.includes("&amp;"))
          clientData.ClientName.replace("&amp;", "&");
        setDcxClientName(clientData.ClientName || "");
        setCoverURL(clientCover);
        // Check for thank you page first to avoid flash of landing page
        if (thankyou === "true") {
          setCurrentStep(Steps.thankYouView);
        } else {
          setCurrentStep(Steps.landingAccountPage);
        }
      } catch (error) {
        console.log(error);
        setCurrentStep(Steps.landingPage);
      }
    };
    fetchClient();

    return () => controller.abort();
  }, [
    clientID,
    urlLocationID,
    setCoverURL,
    setCurrentStep,
    isFetching,
    selectedOption,
    setClientID,
    setLocationID,
    urlClientID,
    setDcxClientName,
    setLogoURL,
    setServiceURL,
    dcxClientName,
    locationID,
    logoURL,
    serviceURL,
    clientCover,
    coverURL,
    setDcxClientData
  ]);

  return (
    <Container style={{ height }}>
      <IntroContainer logoURL={logoURL} clientName={dcxClientName}>
        {clientExist && currentStep === Steps.landingAccountPage && (
          <HelpDeskView />
        )}
        {clientExist && currentStep === Steps.findItemView && <FindItemView />}
        {clientExist && currentStep === Steps.pickOrderView && (
          <PickOrderView />
        )}
        {clientExist && currentStep === Steps.thankYouView && <ThankYouView />}

        {!clientExist && (
          <div className="centrado">
            <br />
            <br />
            Gathering client information
            <br />
            <br />
            <CircularProgress />
          </div>
        )}
      </IntroContainer>
    </Container>
  );
}
